<template>
  <div
    class="form-no-messages"
    style="position:relative"
  >
    <v-container>
      <div
        v-if="$store.getters.getMobileModel !== 'PDA'"
        class="qrcode-wrap"
        :style="{display: showQrScaner}"
      >
        <QrCodeScanComponent @scan-result="onPCodeScan" />
      </div>
      <v-row dense>
        <v-col
          :cols="$store.getters.getMobileModel !== 'PDA' ? 6 : 7"
        >
          <v-text-field
            id="input-pcode"
            v-model="qrKey"
            label="파레트번호"
            placeholder="QR 스캔"
            autocomplete="off"
            clearable
            @keyup.enter.prevent="onEnterPcode"
          />
        </v-col>
        <v-col
          v-if="$store.getters.getMobileModel !== 'PDA'"
          class="pb-0 pt-4 pl-0"
          cols="1"
        >
          <v-icon
            @click="showQrScaner = showQrScaner === 'none' ? 'block' : 'none'; qrKey=null"
          >
            mdi-camera
          </v-icon>
        </v-col>
        <v-col
          :cols="5"
        >
          <v-text-field
            v-model="readQrKey"
            label="현 파레트번호"
            autocomplete="off"
            readonly
          />
        </v-col>
      </v-row>
      <div style="margin-top:14px; background-color:black;">
        <dx-data-grid
          ref="refGoodsInputGrid"
          :data-source="goodsInputListInfo"
          :show-borders="true"
          :show-row-lines="false"
          :show-column-lines="true"
          :hover-state-enabled="true"
          :allow-column-resizing="true"
          column-resizing-mode="widget"
          :allow-column-reordering="true"
          :row-alternation-enabled="true"
          height="200"
          :focused-row-enabled="true"
          :focused-row-key.sync="focusedRowKey"
          :auto-navigate-to-focused-row="false"
          key-expr="품번"
          @focused-row-changed="onSelectionChanged"
        >
          <DxColumnFixing :enabled="true" />
          <DxColumn
            :allow-editing="false"
            caption="품번"
            data-field="품번"
          />
          <DxColumn
            :allow-editing="false"
            :caption="captionText"
            data-field="총입고수량"
            format="#,##0"
            width="70"
          />
          <DxColumn
            :allow-editing="false"
            caption="잔량"
            data-field="잔량"
            format="#,##0"
            width="70"
          />
          <dx-paging :enabled="false" />
          <dx-scrolling
            mode="virtuala"
            show-scrollbar="always"
            :use-native="false"
          />
          <dx-sorting mode="multiple" />
        </dx-data-grid>
      </div>
      <div style="margin-top:14px; background-color:black;">
        <dx-data-grid
          ref="refGoodsInputGrid"
          :data-source="goodsReceiptList"
          :show-borders="true"
          :show-row-lines="false"
          :show-column-lines="true"
          :hover-state-enabled="true"
          :allow-column-resizing="true"
          column-resizing-mode="widget"
          :allow-column-reordering="true"
          :row-alternation-enabled="true"
          :height="gridHeight"
          :focused-row-enabled="false"
          :auto-navigate-to-focused-row="false"
          @toolbar-preparing="onToolbarPreparing"
        >
          <DxColumnFixing :enabled="true" />
          <DxColumn
            :allow-editing="true"
            caption="일자"
            data-field="발생일자"
            data-type="date"
            format="yy/MM/dd"
            sort-order="desc"
            width="100"
          />
          <DxColumn
            :allow-editing="false"
            caption="품번"
            data-field="품번"
          />
          <DxColumn
            :allow-editing="true"
            caption="구분"
            data-field="입출고구분"
            :visible="true"
            width="80"
          >
            <DxLookup
              :data-source="receiptLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allow-editing="false"
            caption="수량"
            data-field="수량"
            format="#,##0"
            width="70"
          />
          <dx-paging :enabled="false" />
          <dx-scrolling
            mode="virtuala"
            show-scrollbar="always"
            :use-native="false"
          />
          <dx-sorting mode="multiple" />
          <template #receiptTitle>
            <div
              class="toolbar-label"
              style="font-size:1.0rem;margin-left:0px;"
            >
              <b>{{ receiptTitle }}</b>
            </div>
          </template>
        </dx-data-grid>
      </div>
      <div>
        <loading
          :active.sync="isLoading"
          color="rgb(2, 110, 156)"
          loader="bars"
        />
      </div>
    </v-container>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import AppLib from '../../share/AppLib'
// eslint-disable-next-line no-unused-vars
import ConstDef from '../../../../MesSmartVue/src/share/ConstDef'
// eslint-disable-next-line no-unused-vars
import HttpService from '../../share/service/HttpService'
import QrCodeScanComponent from '../../components/QrCodeScanComponent'
import DxDataGrid, { DxColumnFixing, DxScrolling, DxColumn, DxPaging, DxSorting, DxLookup } from 'devextreme-vue/data-grid'

export default {
  name: 'PalletInfo',
  components: {
    Loading,
    QrCodeScanComponent,
    DxDataGrid,
    DxColumnFixing,
    DxScrolling,
    DxColumn,
    DxPaging,
    DxLookup,
    DxSorting
  },
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      qrKey: '',
      readQrKey: '',
      selectedRow: null,
      goodsInputListInfo: null,
      focusedRowKey: null,
      captionText: '입고',
      // 입출고 내역
      goodsReceiptList: null,
      gridHeight: null,
      receiptLookup: null,
      receiptTitle: '입출고 현황',
      locationLookup: null,
      // qrcode scan
      showQrScaner: 'none'
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
    }
    // HttpService.reqPost(null, '/isLogin')
    this.receiptLookup = ConstDef.GOODS_INOUT_CODE
    this.locationLookup = this.$store.getters.getLocation
  },
  mounted () {
    this.gridHeight = (this.$Q('html').height() - 360)
    console.log(this.gridHeight)
    this.initInput()
  },
  updated () {
  },
  methods: {
    initInput () {
      this.qrKey = null
      this.$Q('#input-pcode').focus()
    },
    onEnterPcode (e) {
      this.goodsReceiptList = null
      let split = null
      try {
        split = AppLib.base64DecodeSubstring(this.qrKey).split('/')
        if (split.length === 1) {
          this.$snotify.error('일련번호를 확인할 수 없습니다.')
          return
        }
        this.qrKey = parseInt(split[1])
      } catch {
        this.$snotify.error('제품정보를 확인할 수 없습니다.')
        this.initInput()
        return
      }
      this.receiptTitle = '입출고 현황'
      this.$_sp.runNoEncodeFindProc('spFindAllPalletInfoByKey', { 입고키: this.qrKey, 품번: split[0].replace('?', ' ') })
        .then((data) => {
          this.goodsInputListInfo = this.$_sp.MakeModel(data)
          console.log(this.goodsInputListInfo)
          if (this.goodsInputListInfo.length > 0) {
            if (this.goodsInputListInfo[0].품목유형 === ConstDef.구매품) {
              this.captionText = '입고'
            } else {
              this.captionText = '실적'
            }
            this.focusedRowKey = this.goodsInputListInfo[0].품번
            this.readQrKey = this.qrKey
            this.qrKey = ''
          } else {
            this.readQrKey = this.qrKey
            this.qrKey = ''
            this.$snotify.error('파레트 정보를 검색할 수 없습니다.')
          }
        })
        .catch(error => {
          this.isLoading = false
          this.initInput()
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onPCodeScan (result) {
      this.qrKey = result
      this.onEnterPcode(null)
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
        this.receiptTitle = `${this.selectedRow.품명}`
        this.refreshGoodsReceiptList()
      }
    },
    refreshGoodsReceiptList () {
      this.$_sp.runNoEncodeFindProc('spFindAllInOutListByKeyAndGoodsNo', { 입고키: this.readQrKey, 품번: this.selectedRow.품번 })
        .then((data) => {
          this.goodsReceiptList = this.$_sp.MakeModel(data)
          this.focusedRowKey = null
        })
        .catch(error => {
          this.isLoading = false
          this.initInput()
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // 자재 입출고
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'receiptTitle'
        }
      )
    }
  }
}
</script>

<style lang="scss">

</style>
